module.exports = __webpack_public_path__ + "media/customizations/jordanranch/logo-09a1d993ed3ad4609ce47eeff9638b9b.png";